import { render, staticRenderFns } from "./imgtex.vue?vue&type=template&id=b6b66ece&"
import script from "./imgtex.vue?vue&type=script&lang=js&"
export * from "./imgtex.vue?vue&type=script&lang=js&"
import style0 from "./imgtex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports